function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import GlobeDesktopHomepageFirstFoldComponent from "./components/globe-desktop-homepage-first-fold/globe-desktop-homepage-first-fold-component";
import GlobeMobileHomepageFirstFoldComponent from "./components/globe-mobile-homepage-first-fold/globe-mobile-homepage-first-fold-component";
import DefaultProps from "./default-props";
class GlobeHomepageFirstFoldComponent extends PureComponent {
    render() {
        const { isMobileOrTabletBrowser } = this.props;
        if (isMobileOrTabletBrowser) {
            return /*#__PURE__*/ _jsx(GlobeMobileHomepageFirstFoldComponent, _object_spread({}, this.props));
        }
        return /*#__PURE__*/ _jsx(GlobeDesktopHomepageFirstFoldComponent, _object_spread({}, this.props));
    }
}
export { GlobeHomepageFirstFoldComponent as default };
GlobeHomepageFirstFoldComponent.defaultProps = DefaultProps;
